import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { howItWorksSteps } from '../data/mock';

export const HowItWorks = () => {
  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative py-24 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Como Trabalhamos
            </h1>
            <p className="text-xl text-gray-300 leading-relaxed">
              Processo estruturado de análise, implementação e acompanhamento.
            </p>
          </div>
        </div>
      </section>

      {/* Process Steps */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="space-y-12">
              {howItWorksSteps.map((step) => (
                <div key={step.step} className="flex gap-8 items-start">
                  <div className="flex-shrink-0">
                    <div className="w-20 h-20 rounded-xl bg-brand-green/10 flex items-center justify-center">
                      <span className="text-3xl font-bold text-brand-green">{step.step}</span>
                    </div>
                  </div>
                  <div className="flex-1 pt-2">
                    <h3 className="text-2xl font-bold text-slate-900 mb-3">
                      {step.title}
                    </h3>
                    <p className="text-lg text-gray-600 leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-slate-900 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-6">
              Quer Saber Mais?
            </h2>
            <p className="text-xl text-gray-300 mb-10 leading-relaxed">
              Entre em contacto para discutirmos o seu projeto.
            </p>
            <Link to="/contact">
              <Button size="lg" className="bg-brand-green hover:bg-brand-green-dark text-white px-10 transition-all duration-300 hover:scale-105">
                Pedir Contacto
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
